<template>
  <el-table
    :data="addressData"
    :show-header="false"
    border
  >
    <el-table-column
      prop="label"
    >
      <template slot-scope="scope">
        <strong>{{ scope.row.label }}</strong>
      </template>
    </el-table-column>
    <el-table-column
      prop="value"
    >
      <template slot-scope="scope">
        <el-tag type="danger" size="small" v-if="scope.row.tag">{{ scope.row.value }}</el-tag>
        <span v-if="!scope.row.tag">{{ scope.row.value }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  export default {
    props: ['userData'],
    data() {
      return {
        addressData: [],
      }
    },
    watch: {
      userData(newVal) {
        this.addressData =  [
          {
            label: 'Irányítószám',
            value: newVal.address && newVal.address.postal_code || ''
          },
          {
            label: 'Város',
            value: newVal.address && newVal.address.city || '',
          },
          {
            label: 'Ország',
            value: newVal.address && newVal.address.country && newVal.address.country.name || '',
          },
          {
            label: 'Megye',
            value: newVal.address && newVal.address.county && newVal.address.county.name || '',
          },
          {
            label: 'Közterület neve',
            value: newVal.address && newVal.address.street || ''
          },
          {
            label: 'Közterület jellege',
            value: newVal.address && newVal.address.street_suffix || ''
          },
          {
            label: 'Házszám',
            value: newVal.address && newVal.address.street_no || ''
          },
          {
            label: 'Emelet',
            value: newVal.address && newVal.address.floor || ''
          },
          {
            label: 'Ajtó',
            value: newVal.address && newVal.address.door_no || ''
          },
        ];

      },

    }
  }
</script>
